import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import devicesColumnTemplate from './target.pug';

const isCampaignWithNoDeviceTargeting = (campaignType/* , campaignSubType */) => campaignType === 'PerformanceMax';

export class ColumnDevices extends CampaignuiBaseColumn {
  constructor({
    i18n,
  }) {
    const localizedTitle = i18n.getString('CampaignSettingsGrid_ColumnHeader_Devices');

    super({
      name: 'Devices',
      type: 'string',
      property: ['Id', 'CampaignCriterions'],
      sortable: false,
      title: 'CampaignSettingsGrid_ColumnHeader_Devices',
      helpId: 'Page_CampaignGrids_Devices',
      i18n,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: localizedTitle }),
    });

    this.i18n = i18n;
  }

  template({ value }) {
    const cid = TargetingSettingsContext.state.get('customer_id');
    const aid = TargetingSettingsContext.state.get('account_id');
    const link = `/campaign/vnext/settings?aid=${aid}&cid=${cid}&campaignId=${value.cmpid}`;
    return devicesColumnTemplate({
      link,
      name: value.devicesName,
      campaignId: value.cmpid,
      isNonClickable: value.isNonClickable,
    });
  }

  get property() {
    return {
      get: ({
        Id, CampaignCriterions, CampaignType, CampaignSubType,
      }) => {
        if (!TargetingSettingsContext.pageContext.Permissions.IsOriginalDeviceTargetingEnabled ||
          isCampaignWithNoDeviceTargeting(CampaignType, CampaignSubType)) {
          return {
            cmpid: Id,
            devicesName: this.i18n.getString('Targeting_Device_AllDevices'),
            isNonClickable: isCampaignWithNoDeviceTargeting(CampaignType, CampaignSubType),
          };
        }

        const devices = _.filter(CampaignCriterions, criterion => criterion.Criterion.Type === 'Device');
        const computers = _.filter(devices, device => device.Criterion.DeviceName === 'Computers');
        const smartphones = _.filter(devices, device => device.Criterion.DeviceName === 'Smartphones');
        const tablets = _.filter(devices, device => device.Criterion.DeviceName === 'Tablets');
        const deviceNames = [];
        let computerAllSelected;
        let smartphoneAllSelected;
        let tabletsAllSelected;

        if (computers && computers.length === 1) {
          computerAllSelected = 'All';
        }
        if (smartphones) {
          smartphoneAllSelected = (smartphones.length === 5 || (smartphones.length === 1 && _.isNull(smartphones[0].Criterion.OSName))) ? 'All' : 'Some';
        }
        if (tablets) {
          tabletsAllSelected = (tablets.length === 4 || (tablets.length === 1 && _.isNull(tablets[0].Criterion.OSName))) ? 'All' : 'Some';
        }

        if (computerAllSelected === 'All' && smartphoneAllSelected === 'All' && tabletsAllSelected === 'All') {
          deviceNames.push(this.i18n.getString('Targeting_Device_AllDevices'));
        } else {
          deviceNames.push(this.i18n.getString(`Targeting_Device_Computers_OperatingSystems_${computerAllSelected}`));
          deviceNames.push(this.i18n.getString(`Targeting_Device_Smartphones_OperatingSystems_${smartphoneAllSelected}`));
          deviceNames.push(this.i18n.getString(`Targeting_Device_Tablets_OperatingSystems_${tabletsAllSelected}`));
        }

        return {
          cmpid: Id,
          devicesName: deviceNames.join(', '),
        };
      },
      key: this.config.property,
    };
  }
}
